import { render, staticRenderFns } from "./rota.vue?vue&type=template&id=b7624532"
import script from "./rota.vue?vue&type=script&lang=js"
export * from "./rota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports